import React from "react"
import styled from "styled-components"
import {TransitionGroup, CSSTransition} from "react-transition-group"

import {Row, Col} from "@irati/ui/src/Layout"
import Spacing from "@irati/ui/src/Spacing"
import id from "@irati/utils/id"
import {Deal as DealType} from "@irati/types"

import DealCard from "../Deal/DealCard"
import "./styles/DealList.css"
import {DealContextProvider} from "@irati/deals/hooks/useDeal"

interface Props {
  deals: DealType[]
  page: string
}

const FlexComponent = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const DealList: React.FC<Props> = (props) => {
  const {deals, page} = props
  const idNamespace = id("deal-list", props)
  return (
    <Row id={idNamespace}>
      <TransitionGroup component={FlexComponent}>
        {deals.map((deal, index) => (
          <CSSTransition key={deal.uuid} classNames="dealList" timeout={{enter: 400, exit: 300}}>
            <Col id={id(`column-${index}`, idNamespace)} md={4} sm={6} xs={12}>
              <Spacing marginBottom={4}>
                <DealContextProvider deal={deal}>
                  <DealCard id={id(deal.uuid, idNamespace)} deal={deal} page={page} />
                </DealContextProvider>
              </Spacing>
            </Col>
          </CSSTransition>
        ))}
      </TransitionGroup>
    </Row>
  )
}

export default DealList
